import { useGoogleMap } from '@react-google-maps/api';
import { setIsSideMenuCollapsed } from 'features/vicinityMapSlice';
import gaFunction from 'lib/ga';
import { useVicinityMapQuery } from 'lib/hooks/queries';
import { useAppDispatch } from 'lib/hooks/redux';
import useWindowDimensions from 'lib/hooks/useWindowDimensions';
import type { IPOI } from 'lib/models/vicinityMap.interface';
import { getCategory, getGMCoordinates, renderDirections } from 'lib/utils';
import React from 'react';
import styled from 'styled-components';

interface Props {
  POI: IPOI;
  directionsRenderer?: google.maps.DirectionsRenderer;
}

const POIButton = ({ POI, directionsRenderer }: Props) => {
  const map = useGoogleMap()!;
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowDimensions();
  const vicinityMapData = useVicinityMapQuery().data!;

  const handlePOIClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // GA
    gaFunction.vmSelectPlacemarkMenu(
      getCategory(POI.vicCategorySysId!, vicinityMapData)
        ? getCategory(POI.vicCategorySysId!, vicinityMapData)!.title
        : 'n/a',
      POI.title
    );

    if (isMobile) {
      dispatch(setIsSideMenuCollapsed(true));
    }

    // render directions polyline on map
    if (directionsRenderer) {
      renderDirections({
        directionsRenderer,
        POI,
        origin: getGMCoordinates(vicinityMapData.main.projectLocationCoordinates),
        map,
        dispatch,
      });
    }
  };

  return (
    <StyledPOIButton
      id={POI.title.replaceAll(' ', '-')}
      className="poi-button cy-poi-button"
      data-cy={`poi-button-${POI.sysId}`}
      onClick={handlePOIClick}
    >
      {POI.title}
    </StyledPOIButton>
  );
};

export default POIButton;

const StyledPOIButton = styled.span`
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  margin: 2% 0;
  padding: 0 4%;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.textColorPoi};
  background-color: ${({ theme }) => theme.colors.buttonColorPoi};
  font-size: clamp(12px, 1.2vw, 14px);
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primaryTextColor};
    background-color: ${({ theme }) => theme.colors.primaryColor};
  }
`;
